import { Button, ButtonVariant } from '@/shared/components/Buttons';
import {
  Card,
  CardBody,
  CardContent,
  CardStyle,
} from '@/shared/components/Card';
import { Dialog } from '@/shared/components/Dialog';
import PopupIcon from '../../../assets/svg/AddUserPopupIcon.svg';

interface CreateModalProps {
  open: boolean;
  onClose: () => void;
  onConfirmCancel: () => void;
}

function CreateModal({ open, onClose, onConfirmCancel }: CreateModalProps) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth={380}>
      <Card style={CardStyle.Elevated} width={380}>
        <CardBody padding="large">
          <div className="flex flex-col items-center gap-6 text-center">
            <div className="flex items-center justify-center w-[137px] h-[137px]">
              <PopupIcon />
            </div>
            <CardContent
              title="Odrzucić zmiany?"
              description="Wprowadzone dane nie zostaną zapisane. Czy na pewno chcesz anulować?"
              className="!px-0 !py-0 flex flex-col items-center !gap-2 !text-[#474A4C] [&>p]:!font-normal"
            />
            <div className="flex flex-row items-center justify-center gap-3 w-full px-5">
              <Button
                label="Kontynuuj edycję"
                onClick={onClose}
                className="!bg-transparent border border-[#DCDDE0] !text-on-surface-variant hover:!bg-neutral-95 hover:border-neutral-70 w-full cursor-pointer !rounded-[8px] !font-medium"
              />
              <Button
                label="Odrzuć zmiany"
                variant={ButtonVariant.Primary}
                onClick={onConfirmCancel}
                className="w-full cursor-pointer !rounded-[8px] !font-medium"
              />
            </div>
          </div>
        </CardBody>
      </Card>
    </Dialog>
  );
}

export default CreateModal;
